import { css, SerializedStyles } from '@emotion/react';
import { useTheme } from '@mui/material';

export const useDataTableStyles = (): SerializedStyles => {
  const theme = useTheme();

  return css`
    .grid-container {
      overflow: auto;
    }

    .pagination {
      padding: ${theme.spacing(2)};
    }

    .data-table {
      table-layout: fixed;
    }

    .table-cell {
      text-overflow: ellipsis;
      overflow: hidden;
      max-width: 100%;
    }

    .header-tip {
      color: ${theme.typography.body2.color};
      font-size: ${theme.typography.body2.fontSize};
      letter-spacing: ${theme.typography.body2.letterSpacing};
      line-height: ${theme.typography.body2.lineHeight};
    }

    .clickable {
      cursor: pointer;
    }
  `;
};
